import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import "./AddSessionTextEditor.css";
// import firepadRef from "../../../../../VideoChatContents/server/firebase";
import ReactPlayer from "react-player";
import firepadRef from "../../../../VideoChatContents/server/firebase";
import useFileHandleS3 from "../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../MediaUploadProgressBar";
import useVdieoHandleS3 from "../../../../CustomHooks/useVideoHandleS3";
import useVideoHandleWithCompress from "../../../../CustomHooks/useVideoHandleWithCompress";

var room_id = firepadRef.key;

export default function AddSession(props) {
  const history = useHistory();

  const [bannerOrVideo, setBannerOrVideo] = useState("0");
  const [loading, setLoading] = useState(false);
  const [inputFieldList, setInputFieldList] = useState([
    {
      title: "",
      description: "",
      event_date: "",
      start_time: "",
      end_time: "",
      fee: "",
      star_id: "",
      image: "",
      video: "",
    },
  ]);
  const [convertedContent, setConvertedContent] = useState(null);
  const [instruction, setInstruction] = useState(null);

  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'learningSession/images', delKey);

  // Video File Handle
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'learningSession/videos', videoDelKey);

  const [registerInput, setRegister] = useState({
    title: "",
    description: "",
    video: "",
    type: "",
    star_id: "",
    event_date: "",
    start_time: "",
    end_time: "",
    fee: "",
    assignment: "",
    registration_start_date: "",
    registration_end_date: "",
    participant_number: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
    e.persist();
    setRegister({ ...registerInput, [e.target.name]: e.target.value });
  };


  const handleChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const handleVideoChange = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
  };

  const registerSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    var banner_or_video = parseInt(bannerOrVideo);
    const fData = new FormData();
    fData.append("banner_or_video", banner_or_video);
    fData.append("image", fileKey);
    fData.append("video", videoKey);
    fData.append("title", registerInput.title);
    fData.append("assignment", registerInput.assignment);
    fData.append(
      "registration_start_date",
      registerInput.registration_start_date
    );
    fData.append("registration_end_date", registerInput.registration_end_date);
    fData.append("event_date", registerInput.event_date);
    fData.append("start_time", registerInput.start_time);
    fData.append("end_time", registerInput.end_time);
    fData.append("fee", registerInput.fee);
    fData.append("participant_number", registerInput.participant_number);
    fData.append("description", convertedContent);
    fData.append("instruction", instruction);
    // fData.append("room_id", room_id);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/learning_session/create`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/learning-session/approved");
        } else {
          setRegister({
            ...registerInput,
            error_list: res.data.errors,
          });
        }
      });
    });
  };

  const handleBannerOrVideo = (e) => {
    setBannerOrVideo(e.target.value);
  };

  return (
    <>
      {inputFieldList.map((x, i) => {
        return (
          <div {...props}>
            <div className="card card-bg mb-2 p-2 ">
              <div className="card card-bg m-2">
                <div className="container-lg">
                  <div className="row">
                    <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                      <form
                        className="p-3"
                        onSubmit={registerSubmit}
                        id="input_form"
                        encType="multipart/form-data"
                      >
                        <div className="form-group row my-4">
                          <label className="col-sm-3 label-text ">Title</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control reply-control"
                              placeholder="Enter title"
                              onChange={handleInput}
                              name="title"
                              value={registerInput.title}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.title}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-4">
                          <label className="col-sm-3 label-text ">
                            Select Video Or Banner
                          </label>
                          <div className="col-sm-9">
                            <select
                              onChange={handleBannerOrVideo}
                              name="video_or_banner"
                              className="form-control reply-control"
                              value={bannerOrVideo}
                            >
                              <option className="text-black" value="0">
                                Banner
                              </option>
                              <option className="text-black" value="1">
                                Video
                              </option>
                            </select>
                          </div>
                        </div>

                        {bannerOrVideo === "0" && (
                          <div className="form-group row my-3">
                            <label className="col-sm-3 label-text ">
                              Banner
                            </label>
                            <div className="col-sm-9 file-x-i">
                              {fileUrl ? (
                                <img
                                  src={fileUrl}
                                  alt="..."
                                  className="demo-preview-image img-fluid"
                                />
                              ) : (
                                ""
                              )}

                              <input
                                type="file"
                                className="form-control reply-control"
                                onChange={(e) => handleChange(e.target.files)}
                                id="image"
                                name="image"
                                accept="image/*"
                              />
                             {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                              <small className="text-danger">
                                {registerInput.error_list?.image}
                              </small>
                            </div>
                          </div>
                         )}

                         {bannerOrVideo === "1" && (
                          <div className="form-group row my-3">
                            <label className="col-sm-3 label-text ">
                              Video
                            </label>
                            <div className="col-sm-9 file-x-i">
                              {videoUrl ? (
                                <>
                                  <ReactPlayer
                                    url={videoUrl}
                                    width="100%"
                                    controls={true}
                                    height="35vh"
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                              <input
                                type="file"
                                className="form-control reply-control"
                                onChange={(e) =>
                                  handleVideoChange(e.target.files)
                                }
                                id="video"
                                name="video"
                                accept="video/mp4"
                              />
                              {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                              <small className="text-danger">
                                {registerInput.error_list?.video}
                              </small>
                            </div>
                          </div>
                        )}

                        <div className="form-group row my-4">
                          <label className="col-sm-3 label-text ">
                            Description
                          </label>
                          <div className="col-sm-9">
                            <CKEditor
                              name="description"
                              data={convertedContent}
                              editor={ClassicEditor}
                              onChange={(event, editor) => {
                                setConvertedContent(editor.getData());
                              }}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.description}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-4">
                          <label className="col-sm-3 label-text ">
                            Instruction
                          </label>
                          <div className="col-sm-9">
                            <CKEditor
                              name="description"
                              data={instruction}
                              editor={ClassicEditor}
                              onChange={(event, editor) => {
                                setInstruction(editor.getData());
                              }}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.instruction}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-4">
                          <label className="col-sm-3 label-text ">
                            Event Date
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="date"
                              className="form-control reply-control "
                              onChange={handleInput}
                              name="event_date"
                              value={registerInput.event_date}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.event_date}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-3 text-warning">
                          <label className="col-sm-3 label-text ">Time</label>
                          <div className="col-sm-4">
                            <input
                              type="time"
                              className="form-control reply-control"
                              onChange={handleInput}
                              name="start_time"
                              value={registerInput.start_time}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.start_time}
                            </small>
                          </div>{" "}
                          <div className="col-sm-1">To</div>
                          <div className="col-sm-4">
                            <input
                              type="time"
                              className="form-control reply-control"
                              onChange={handleInput}
                              name="end_time"
                              value={registerInput.end_time}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.end_time}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-4">
                          <label className="col-sm-3 label-text ">
                            Event Type
                          </label>
                          <div className="col-sm-9">
                            <select
                              onChange={handleInput}
                              name="assignment"
                              className="form-control reply-control"
                              value={registerInput.assignment}
                            >
                              <option className="text-black" value="">
                                --- Choose One ---
                              </option>
                              <option className="text-black" value="0">
                                Without Assignment
                              </option>
                              <option className="text-black" value="1">
                                With Assignment
                              </option>
                            </select>
                            <small className="text-danger">
                              {registerInput.error_list?.assignment}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-3 text-warning">
                          <label className="col-sm-3 label-text ">
                            Registration Date
                          </label>
                          <div className="col-sm-4">
                            <input
                              type="date"
                              className="form-control reply-control"
                              onChange={handleInput}
                              name="registration_start_date"
                              value={registerInput.registration_start_date}
                            />
                            <small className="text-danger">
                              {
                                registerInput.error_list
                                  ?.registration_start_date
                              }
                            </small>
                          </div>{" "}
                          <div className="col-sm-1">To</div>
                          <div className="col-sm-4">
                            <input
                              type="date"
                              className="form-control reply-control"
                              onChange={handleInput}
                              name="registration_end_date"
                              value={registerInput.registration_end_date}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.registration_end_date}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-3">
                          <label className="col-sm-3 label-text ">Fee</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control reply-control"
                              placeholder="Enter fee $"
                              onChange={handleInput}
                              name="fee"
                              value={registerInput.fee}
                              min={0}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.fee}
                            </small>
                          </div>
                        </div>

                        <div className="form-group row my-3">
                          <label className="col-sm-3 label-text ">
                            Participant Number
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control reply-control"
                              placeholder="Enter participant number"
                              onChange={handleInput}
                              name="participant_number"
                              value={registerInput.participant_number}
                              min={0}
                            />
                            <small className="text-danger">
                              {registerInput.error_list?.participant_number}
                            </small>
                          </div>
                        </div>

                        {/* Create Submit */}
                        <div className="row justify-content-center aligns-items-center my-4 mt-5">
                          <div className="col-md-3"></div>
                          <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                            {loading ? (
                              <>
                                <button className="btn btnCreate">
                                  <i className="fas fa-spinner fa-pulse"></i>{" "}
                                </button>
                              </>
                            ) : (
                              <button
                                className="btn btnCreate fw-bold"
                                type="submit"
                              >
                                Save
                              </button>
                            )}
                          </div>
                        </div>
                        {/* Create Submit End */}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
